import React from 'react';
import {DatasetIdentifier} from "api/model/dataset/datasetModels";
import {useGetDatasetInfo} from "api/api-hooks/datasets-hooks";

interface IDatasetTitleProps {
    identifier: string| DatasetIdentifier | null ;
}

export default function DatasetTitle(props: IDatasetTitleProps) {
    const query = useGetDatasetInfo(props.identifier)

    const loading = query.isLoading;
    const missing = props.identifier == null;

    const titleBody = () => {
        if (missing) {
            return "Missing dataset identifier"
        }

        if (loading) {
            return <i>{props.identifier} (Loading...)</i>
        }

        if (query.isError) {
            return props.identifier + " - Error: " + query.error?.message
        }

        if (query.isSuccess) {
            return query.data?.toString()
        }
    }

    return <>
        { titleBody() }
    </>
}